export enum MotionBoxType {
  None = 0,
  CustomerOrder = 10,
  WarehouseOrder = 20,
  Shipment = 30,
}

export enum MotionStatusErrorCode {
  InvalidClient = 8110,
  InvalidStatus = 8120,
  Unexpected = 8199,
}
